module.exports = __webpack_public_path__ + "img/fireBIM_uncheck.fa81824e.png";